import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ButtonModule } from '@psei/ng/button';
import { PpbSharedModule } from 'projects/ppb-shared-library/src/lib/ppb-shared.module';
import { PseiNgCustomModule } from 'projects/ppb-shared-library/src/lib/psei-ng-custom.module';
import { PpbRegistrationCodesComponent } from './ppb-registration-codes.component';


@NgModule({
  declarations: [PpbRegistrationCodesComponent],
  imports: [
    CommonModule,
    PpbSharedModule,
    PseiNgCustomModule,
    ButtonModule,
  ]
})
export class PpbRegistrationCodesModule {
}
